import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "5%",
    PaddingTop: "2%",
  },
  actionButtons: {
    marginTop: "-3%",
    textAlign: "center",
    paddingLeft: "25px",
  },
  tableWrapper: {
    width: "95%",
    paddingLeft: "2%",
    margin: "2% 3%",
  },

  bodyContainer: {
    maxWidth: "92%",
    flexGrow: 1,
    margin: "0 auto",
    marginTop: "20px",
  },
  bodyContainer1: {
    maxWidth: "90%",
    margin: "0 auto",
    marginTop: "20px",
  },
  row: {
    "& button": {
      display: "none",
    },
    "&:hover": {
      "& button": {
        display: "inline-block",
      },
    },
  },
  searchCategory: {
    marginLeft: "25rem",
    marginRight: "1rem",
    width: "504px",
    "& div": {},
  },
  textPrimary: {
    color: theme.palette.primary.main,
  },

  textSecondary: {
    color: theme.palette.secondary.main,
  },
  miTable: {
    "& .MuiPaper-root": {
      boxShadow: "2px 5px 15px #888888",
    },
    "& .MuiToolbar-root": {
      "& .material-icons": {
        color: theme.palette.secondary.main,
      },
    },
    "& .MuiTable-root": {
      borderCollapse: "separate",
    },

    "& .MuiTableSortLabel-root:hover": {
      color: "inherit",
    },
    "& .MuiTableCell-paddingCheckbox": {
      right: "0",
    },
  },

  MuiTable: {
    "& tbody td": {
      fontSize: theme.typography.h2.fontSize,
    },
  },
  IconBorder: {
    width: "42px",
    height: "40px",
    padding: "5px",
    textAlign: "center",
    borderRadius: "5px",
    backgroundColor: "#320032",
    margin: "auto 0 auto auto",
  },
}));

export default useStyles;
